module.exports = __webpack_public_path__ + "static/media/carousel2.77a4bae0.jpeg";